import {
  saVersionListConstants,
  saVersionUploadConstants,
  saVersionDeleteConstants,
  saVersionConstants,
} from "../_redux-constants";

export function saVersionListReducer(
  state = {
    saVersionListLoading: false,
    saVersionListData: null,
    saVersionListError: null,

    saVersionUploadLoading: false,
    saVersionUploadData: null,
    saVersionUploadError: null,

    saVersionLoading: false,
    saVersionData: null,
    saVersionError: null,
  },
  action
) {
  switch (action.type) {
    case saVersionListConstants.SAVERSION_LIST_LOADING:
      return Object.assign({}, state, {
        saVersionListLoading: true,
        saVersionListData: null,
        saVersionListError: null,
      });
    case saVersionListConstants.SAVERSION_LIST_SUCCESS:
      return Object.assign({}, state, {
        saVersionListLoading: false,
        saVersionListData: action.data,
      });
    case saVersionListConstants.SAVERSION_LIST_FAILURE:
      return Object.assign({}, state, {
        saVersionListLoading: false,
        saVersionListData: null,
        saVersionListError: action.error,
      });
    case saVersionUploadConstants.SAVERSION_UPLOAD_LOADING:
      return Object.assign({}, state, {
        saVersionUploadLoading: true,
        saVersionUploadData: null,
        saVersionUploadError: null,
      });
    case saVersionUploadConstants.SAVERSION_UPLOAD_SUCCESS:
      return Object.assign({}, state, {
        saVersionUploadLoading: false,
        saVersionUploadData: action.data,
      });
    case saVersionUploadConstants.SAVERSION_UPLOAD_FAILURE:
      return Object.assign({}, state, {
        saVersionUploadLoading: false,
        saVersionUploadData: null,
        saVersionUploadError: action.error,
      });
    case saVersionConstants.SAVERSION_LOADING:
      return Object.assign({}, state, {
        saVersionLoading: true,
        saVersionData: null,
        saVersionError: null,
      });
    case saVersionConstants.SAVERSION_SUCCESS:
      return Object.assign({}, state, {
        saVersionLoading: false,
        saVersionData: action.data,
      });
    case saVersionConstants.SAVERSION_FAILURE:
      return Object.assign({}, state, {
        saVersionLoading: false,
        saVersionData: null,
        saVersionError: action.error,
      });
    case saVersionDeleteConstants.SAVERSION_DELETE_LOADING:
      return Object.assign({}, state, {
        saVersionDeleteLoading: true,
        saVersionDeleteData: null,
        saVersionDeleteError: null,
      });
    case saVersionDeleteConstants.SAVERSION_DELETE_SUCCESS:
      return Object.assign({}, state, {
        saVersionDeleteLoading: false,
        saVersionDeleteData: action.data,
      });
    case saVersionDeleteConstants.SAVERSION_DELETE_FAILURE:
      return Object.assign({}, state, {
        saVersionDeleteLoading: false,
        saVersionDeleteData: null,
        saVersionDeleteError: action.error,
      });
    default:
      return state;
  }
}
